import SearchField from '../../../@types/SearchField';
import { UserRecordWhereInput } from '../../../__generated__/graphql';

const USER_RECORDS_TABLE_SEARCH_FIELDS: SearchField<UserRecordWhereInput>[] = [];

export default USER_RECORDS_TABLE_SEARCH_FIELDS;
